import { render, staticRenderFns } from "./DisplayRelations.vue?vue&type=template&id=cc391d30&"
import script from "./DisplayRelations.vue?vue&type=script&lang=js&"
export * from "./DisplayRelations.vue?vue&type=script&lang=js&"
import style0 from "./DisplayRelations.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports